<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img v-if="partner_name==null" :src="logo" class="sidebar-logo">
        <h1 v-else class="sidebar-title">{{ partner_name }}</h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="partner_name==null" :src="logo" class="sidebar-logo">
        <h1 class="sidebar-title" v-if="partner_name==null">{{ title }}</h1>
        <img v-if="partner_name!=null&&partner_avatar!=null" :src="upload_path+partner_avatar" class="sidebar-logo">
        <!-- <h1 class="sidebar-title">{{partner_avatar}}</h1> -->
        <h1 class="sidebar-title" v-if="partner_name!=null">{{ partner_name }}</h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'partner_name',
      'partner_avatar'
    ])
  },
  data() {
    return {
      title: '德誠資訊',
      logo: require('@/assets/logo/德誠資訊logo_3.png'),
      // 圖片網址位置
      upload_path: ''
    }
  },
  async mounted() {
    // 圖片網址位置
    this.upload_path = process.env.VUE_APP_BASE_API_UPLOAD
    await this.$store.dispatch('user/getInfo')
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 50px;
      height: 50px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
